import React, { useEffect } from 'react';

import { Button, primaryTheme } from '@src/components/Buttons';
import CheckIcon from '@src/components/Icon/CheckIcon';
import { Spacer } from '@src/components/Spacer';
import { H3, P2 } from '@src/components/Typography';

import Modal from '../Modal';
import type { BasicModalProps } from '../types';

import { Container } from './styles';

const ENTER = 'Enter';

/**
 * Modal gives a user the confirmation that a previous event succeeded
 */
const OnlyDesktopAvailableModal: React.FC<Required<BasicModalProps>> = ({
  isOpen,
  onClose,
}) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent): void => {
      if (event.key === ENTER) {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return (): void => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Container>
        <H3>We are sorry</H3>
        <Spacer height="12px" />
        <P2>
          Our editor is currently only usable on desktop computers. Please login
          on a computer to start creating.
        </P2>
        <Spacer height="24px" />
        <Button
          appendIcon
          icon={{
            component: CheckIcon,
            height: '9px',
          }}
          label="Got it"
          name="onlyDesktopModalCloseButton"
          theme={primaryTheme}
          width="130px"
          onClick={onClose}
        />
      </Container>
    </Modal>
  );
};

export default OnlyDesktopAvailableModal;
